import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-page flex items-center justify-center p-6">
      <div className="bg-surface border border-border-subtle rounded-lg p-8 text-center max-w-md w-full animate-fade-in">
        <p className="text-xs uppercase tracking-wider text-text-faint">404</p>
        <h1 className="text-lg font-semibold text-white mt-2">
          Page not found
        </h1>
        <p className="text-sm text-text-muted mt-1.5 mb-5">
          That route doesn't exist.
        </p>
        <Link
          to="/schedules"
          className="text-brand hover:text-brand-hover text-sm font-medium"
        >
          ← Back to Schedules
        </Link>
      </div>
    </div>
  );
}
